import {
	type ChangeEvent,
	useCallback,
	useContext,
	useEffect,
	useState,
} from "react";
import { createPortal } from "react-dom";
import { BsPlus } from "react-icons/bs";
import { FiX } from "react-icons/fi";

import { Button } from "~/components/Button";
import { Modal } from "~/components/Modal";
import { SearchInput } from "~/components/SearchInput";
import { PersonalTrainerForm } from "~/forms/PersonalTrainerForm";
import { useQuery } from "~/hooks/useQuery";
import { debouncer } from "~/utils/debounce";

import { context } from "./context";

const debounce = debouncer();

export const Header: React.FC = () => {
	const query = useQuery();
	const { handleChangeSearch, filter } = useContext(context);
	const [showModal, setShowModal] = useState<boolean>(false);
	const [search, setSearch] = useState<string | undefined>(
		() => query.get("cpf") ?? undefined,
	);

	const handleToggleModal = useCallback(() => {
		setShowModal((state) => !state);
	}, []);

	const handleSearch = useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			setSearch(e.target.value);
			debounce(() => {
				handleChangeSearch(e.target.value.replace(/[.-]/g, ""));
			});
		},
		[handleChangeSearch],
	);

	useEffect(() => {
		const cpf = query.get("cpf") ?? undefined;
		if (!cpf) {
			console.log("here");
			setSearch("");
			handleChangeSearch("");
		}
	}, [query, handleChangeSearch]);

	return (
		<div className="flex items-center justify-between p-2 py-3 border-b-2 border-b-slate-300">
			<div className="max-w-[270px]">
				<SearchInput
					defaultValue={filter.documentNumber}
					placeholder="Buscar por nome ou CPF"
					value={search}
					onChange={handleSearch}
				/>
			</div>
			<div className="max-w-[270px]">
				<Button onClick={handleToggleModal}>
					<BsPlus size={26} /> Novo Personal
				</Button>

				{createPortal(
					<Modal visible={showModal}>
						<div className="flex items-center justify-between">
							<h1 className="text-xl">Cadastrar Novo Personal Trainer</h1>
							<button
								type="button"
								className="p-2 rounded-full hover:bg-slate-50"
								onClick={handleToggleModal}
							>
								<FiX size={26} />
							</button>
						</div>

						<PersonalTrainerForm onSubmit={handleToggleModal} />
					</Modal>,
					document.getElementById("modals")!,
				)}
			</div>
		</div>
	);
};
